/**
 * CursorGlow — золотой «прожектор», следующий за курсором.
 *
 * Запрошен владельцем 2026-06-10: «нравится этот фоновой свет, который
 * стоит указатель мышки, а то только чёрный фон неинтересно».
 *
 * Fixed-слой поверх секций (pointer-events: none), радиальное тёплое
 * пятно с ленивым догоном через lerp в rAF — свет «плывёт» за мышью.
 * Только для устройств с курсором (pointer: fine); при reduced-motion
 * догон мгновенный.
 */
import { useEffect, useRef } from "react";
import { prefersReducedMotion } from "../lib/motion";

const EASE = 0.085; // скорость догона: меньше = ленивее шлейф

export function CursorGlow() {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!window.matchMedia("(pointer: fine)").matches) return;
    const el = ref.current;
    if (!el) return;

    let targetX = window.innerWidth / 2;
    let targetY = window.innerHeight * 0.4;
    let x = targetX;
    let y = targetY;
    let raf = 0;
    let visible = false;

    const onMove = (e: MouseEvent) => {
      targetX = e.clientX;
      targetY = e.clientY;
      if (!visible) {
        visible = true;
        el.style.opacity = "1";
      }
    };

    const tick = () => {
      const k = prefersReducedMotion ? 1 : EASE;
      x += (targetX - x) * k;
      y += (targetY - y) * k;
      el.style.background = `radial-gradient(640px circle at ${x}px ${y}px, rgba(212,166,86,0.085), rgba(212,166,86,0.03) 38%, transparent 68%)`;
      raf = requestAnimationFrame(tick);
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    raf = requestAnimationFrame(tick);
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden
      className="pointer-events-none fixed inset-0 z-[40]"
      style={{ opacity: 0, transition: "opacity 600ms ease" }}
    />
  );
}
